/* IssueTable.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./IssueTable.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useIntl } from 'react-intl-next';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { IssueKeyNode } from './issue-table-components/IssueKeyNode';
import { IssuePriorityNode } from './issue-table-components/IssuePriorityNode';
import { IssueStatusNode } from './issue-table-components/IssueStatusNode';
import { IssueTextNode } from './issue-table-components/IssueTextNode';
import { IssueTypeNode } from './issue-table-components/IssueTypeNode';
import { IssueUserNode } from './issue-table-components/IssueUserNode';
import { messages } from './messages';
var styles = {
  tableWrapper: "_2rko1mok _1dqonqa1 _1h6d1l7x _189ee4h9 _1reo1wug",
  table: "_1dqo15vq _1kqm1n9t",
  header: "_1dqoglyw",
  headerCell: "_11c81vhk _1dqonqa1 _1h6d1l7x _189ee4h9 _syazazsu _bfhkhfxm _ca0qze3t _u5f3u2gc _n3tdze3t _19bvu2gc _4t3i1ylp _s7n4nkob",
  cell: "_1reo15vq _18m915vq _1dqonqa1 _1h6d1l7x _189ee4h9 _ca0qze3t _u5f3u2gc _n3tdze3t _19bvu2gc _1bsb1osq _4t3i1ylp"
};
var HeaderRow = function HeaderRow(_ref) {
  var headerLabels = _ref.headerLabels;
  return headerLabels.map(function (item, index) {
    return /*#__PURE__*/React.createElement("th", {
      key: "issue.header.".concat(index),
      style: _objectSpread({
        width: item.width
      }, index === 0 && {
        paddingLeft: "var(--ds-space-100, 8px)"
      }),
      className: ax([styles.headerCell])
    }, item.label);
  });
};
var BodyRows = function BodyRows(_ref2) {
  var issues = _ref2.issues,
    analyticsAttributes = _ref2.analyticsAttributes;
  return issues.map(function (issue, rowIndex) {
    var issueNode = issue.node;
    var issueTypeField = issueNode.issueTypeField;
    var issueStatus = issueNode.status;
    var issueAssignee = issueNode.assigneeField.user;
    var issuePriority = issueNode.priorityField;
    return /*#__PURE__*/React.createElement("tr", {
      key: "issue.row.".concat(rowIndex)
    }, /*#__PURE__*/React.createElement("td", {
      // Override to avoid global first child padding
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
      style: {
        paddingLeft: "var(--ds-space-100, 8px)"
      },
      className: ax([styles.cell])
    }, /*#__PURE__*/React.createElement(Inline, {
      alignBlock: "center",
      alignInline: "start",
      space: "space.075"
    }, /*#__PURE__*/React.createElement(IssueTypeNode, {
      IssueTypeField: issueTypeField
    }), /*#__PURE__*/React.createElement(IssueKeyNode, {
      url: issueNode.webUrl,
      issuekey: issueNode.key,
      analyticsAttributes: analyticsAttributes
    }), /*#__PURE__*/React.createElement(IssueTextNode, {
      text: issueNode.summary
    }))), /*#__PURE__*/React.createElement("td", {
      className: ax([styles.cell])
    }, /*#__PURE__*/React.createElement(IssueStatusNode, {
      status: issueStatus
    })), /*#__PURE__*/React.createElement("td", {
      className: ax([styles.cell])
    }, /*#__PURE__*/React.createElement(IssueUserNode, {
      user: issueAssignee
    })), /*#__PURE__*/React.createElement("td", {
      className: ax([styles.cell])
    }, /*#__PURE__*/React.createElement(IssuePriorityNode, {
      IssuePriorityField: issuePriority
    })));
  });
};
export var IssueTable = function IssueTable(_ref3) {
  var issues = _ref3.issues,
    analyticsAttributes = _ref3.analyticsAttributes;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var headerLabels = [{
    label: formatMessage(messages.headerWork),
    width: '60%'
  }, {
    label: formatMessage(messages.headerStatus),
    width: '15%'
  }, {
    label: formatMessage(messages.headerAssignee),
    width: '15%'
  }, {
    label: formatMessage(messages.headerPriority),
    width: '10%'
  }];
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.tableWrapper
  }, /*#__PURE__*/React.createElement("table", {
    "data-testid": "issue-table",
    className: ax([styles.table])
  }, /*#__PURE__*/React.createElement("thead", {
    className: ax([styles.header])
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(HeaderRow, {
    headerLabels: headerLabels
  }))), /*#__PURE__*/React.createElement("tbody", null, issues.length > 0 ? /*#__PURE__*/React.createElement(BodyRows, {
    issues: issues,
    analyticsAttributes: analyticsAttributes
  }) : /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    align: "center",
    colSpan: headerLabels.length,
    className: ax([styles.cell])
  }, /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    alignInline: "center"
  }, formatMessage(messages.noResultsMessage)))))));
};